import { render, staticRenderFns } from "./TextMenu.vue?vue&type=template&id=118347f5"
import script from "./TextMenu.vue?vue&type=script&lang=ts"
export * from "./TextMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports